import {Directive} from '@angular/core'

@Directive({selector: '[click-to-edit-input]'})
export class ClickToEditInput {}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/click-to-edit/click.to.edit.input.directive.ts